import { render, staticRenderFns } from "./UpdateMetrics.vue?vue&type=template&id=0702c822&scoped=true"
import script from "./UpdateMetrics.vue?vue&type=script&lang=js"
export * from "./UpdateMetrics.vue?vue&type=script&lang=js"
import style0 from "./UpdateMetrics.vue?vue&type=style&index=0&id=0702c822&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0702c822",
  null
  
)

export default component.exports